import { render, staticRenderFns } from "./audit-confirmation-flag-checkbox.vue?vue&type=template&id=2afe4528&scoped=true&"
import script from "./audit-confirmation-flag-checkbox.vue?vue&type=script&lang=js&"
export * from "./audit-confirmation-flag-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afe4528",
  null
  
)

export default component.exports